export const segmentFilters = [
  {
    name: 'registration_player_attributes',
    items: [
      { name: 'registration_timestamp', comparable: true, type: 'date_picker' },
      { name: 'latest_deposit_timestamp', comparable: true, type: 'date_picker' },
      { name: 'latest_bet_timestamp', comparable: true, type: 'date_picker' },
      { name: 'latest_sport_bet_timestamp', comparable: true, type: 'date_picker' },
      { name: 'latest_games_bet_timestamp', comparable: true, type: 'date_picker' },
      { name: 'seconds_since_registration', comparable: true, type: 'time' },
      { name: 'seconds_since_last_deposit', comparable: true, type: 'time' },
      { name: 'seconds_since_last_bet', comparable: true, type: 'time' },
      { name: 'seconds_since_last_sports_bet', comparable: true, type: 'time' },
      { name: 'seconds_since_last_games_bet', comparable: true, type: 'time' },
      { name: 'player_country_code', comparable: false, type: 'text', dictionary: 'countries' },
      { name: 'player_region_code', comparable: false, type: 'text', dictionary: 'regions' },
      { name: 'player_contacts', comparable: false, type: 'player_contacts' },
      { name: 'player_affiliate_id', comparable: false, type: 'player_affiliate_id' },
      { name: 'player_sub_affiliate_id', comparable: false, type: 'player_sub_affiliate_id' },
    ],
  },
  {
    name: 'deposits',
    items: [
      { name: 'has_deposits', comparable: false, type: 'boolean' },
      { name: 'favourite_payment_system_id', comparable: false, type: 'text', dictionary: 'paymentsSystems' },
      { name: 'deposits_count', comparable: true, type: 'number' },
      { name: 'deposits_sum', comparable: true, type: 'number' },
    ],
  },
  {
    name: 'gaming_activity',
    items: [
      { name: 'betting_profit_sum', comparable: true, type: 'number' },
      { name: 'has_bets', comparable: false, type: 'boolean' },
      { name: 'favourite_bet_by_sum', comparable: false, type: 'sport_casino' },
      { name: 'favourite_bet_by_count', comparable: false, type: 'sport_casino' },
      { name: 'has_sports_bets', comparable: false, type: 'boolean' },
      { name: 'has_games_bets', comparable: false, type: 'boolean' },
      { name: 'favourite_sport_type', comparable: false, type: 'text', dictionary: 'sportType' },
      { name: 'favourite_sport_league', comparable: false, type: 'text', dictionary: 'sportLeague' },
      { name: 'sport_bets_count', comparable: true, type: 'number' },
      { name: 'sport_bets_sum', comparable: true, type: 'number' },
      { name: 'sport_bets_live_count', comparable: true, type: 'number' },
      { name: 'sport_bets_live_sum', comparable: true, type: 'number' },
      { name: 'games_bets_count', comparable: true, type: 'number' },
      { name: 'games_bets_sum', comparable: true, type: 'number' },
    ],
  },
];
